import { useEffect, useRef } from 'react';
import { useClearCursor } from '../../stores/stream-screen.store';
import { useSelectionExists } from '../../stores/useStreamSelection';

/**
 * Hook that clears the cursor whenever a selection appears (transitions from no selection to having a selection).
 * This ensures that when a user creates a selection, the cursor is automatically cleared.
 */
export function useClearCursorOnSelection() {
  const selectionExists = useSelectionExists();
  const clearCursor = useClearCursor();
  const previousSelectionExists = useRef<boolean>(false);

  useEffect(() => {
    // If selection just appeared (didn't exist before, but exists now)
    if (!previousSelectionExists.current && selectionExists) {
      clearCursor();
    }

    // Update the ref for the next render
    previousSelectionExists.current = selectionExists;
  }, [selectionExists, clearCursor]);
}
